import styled from '@emotion/styled';
import { useI18n } from '@i18n/useI18n';
import {memo} from 'react';
import AnimatedPercentage from '@components/Animation/AnimatedPercentage';
import moment from 'moment';
import {useSearch} from '@providers/SearchProvider';
import { useStore } from '@store/appStore';
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import fixedNumber from '@utils/fixedNumber';

const randomAbsence = Math.random() * 100 + 1;

const Container = styled.span<{ large: boolean; future: boolean, swipe?: boolean }>`
  /* background-color: yellow; */
  opacity: ${({ future }) => (future ? 0.5 : 1)};
  display: flex;
  white-space: nowrap;
  
`;
const PercentageContainer = styled.div<{swipe:boolean}>`
  margin-left: 3px;
  font-size: ${props => props.swipe? "18px !important": null};
  `;

const Title = styled.div<{swipe:boolean}>`
  font-size: ${props => props.swipe?"18px !important":props.theme.fontSizes.tiny + "px"};
`;

interface IProps {
  absence?: number,
  courseAbsence?: number,
  loading?: boolean,
  combinedSchedule?: null,
  swipe?:boolean,
}

export const StudentStatsSummary = ({absence = randomAbsence, courseAbsence = randomAbsence, loading = false, combinedSchedule = null, swipe}:IProps) => {
  const i18n = useI18n();
  const {settings} = useStore();
  const normalNum = (num) => (num > 0 ? num.toFixed(1) : '0');
  const { registrationQuery } = useSearch();
  const isInFuture = moment(registrationQuery.date).isAfter(moment());
  const statsFields = [{ title: 'total', data: normalNum(absence), large: false, percentage: true }];

  if (!combinedSchedule) {
    statsFields.unshift({ title: 'class', data: normalNum(courseAbsence), large: true, percentage: true });
  }

  

  return (
    <>
      {statsFields.map(({ title, large, percentage, data }, i) => {
        if (data) {
          return (
            <Container future={isInFuture} key={i} large={large}>
              <Title swipe={swipe} >{i18n.t(title)}:</Title>
              <PercentageContainer swipe={swipe} >
                {percentage ? <AnimatedPercentage bold={true} content={fixedNumber(ShowabsenceOrAttendance(settings.SHOWPRESENCE, data)).toString()} loading={loading} /> : <b>{data}</b>}
              </PercentageContainer>
            </Container>
          );
        }
      })}
    </>
  );
};

export default memo(StudentStatsSummary);
